import { UsersAppController } from '../controller/UsersAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class UsersAppWebComponent extends BaseWebComponentElement {
  private _externalFilters: Array<any> = [];

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: UsersAppController,
    });
  }

  set externalFilters(filters: Array<any>) {
    this._externalFilters = filters;
  }

  get externalFilters() {
    return this._externalFilters;
  }

  setPageNumber(page: number) {
    if (this.controller) {
      this.controller.view.dom.$grid.pageNumber = page || 1;
    }
  }
}
